/* eslint-disable */
import * as api from '../api';
import * as ProgramTypes from '../../state/reducer/calendar/programTypes';
import * as AppState from '../../state/reducer/app/appState';

let programCache = false;
const teamProgramCache = {};
let programLoaded = false;
const DialogService = {
    // eslint-disable-next-line
    inform: (param1, param2, param3) => console.error(param1, param2, param3),
};

export const addProgramToCalendar = async (postData) =>
    await api.post('/v5/addProgramToCalendar', postData);

export const addSport = async (id, sportId) => {
    const sport = { sportId };
    return await api.post(`/1.0/coach/programs/addSport/${id}`, sport);
};

export const clone = async (groupId) =>
    await api.get(`/1.0/coach/group/cloneGroup/${groupId}`);

export const cloneProgram = async (programId) =>
    await api.get(`/1.0/coach/programs/cloneProgram/${programId}`);

export const copyProgramWorkoutToNewDay = async (
    programId,
    pwId,
    toDate,
    toTimelineDate
) => {
    const data = {
        toProgramId: programId,
        pwId,
        toDate,
        toTimelineDate,
    };
    return await api.post('/2.0/coach/calendar/copyProgramWorkout', data);
};

export const create = async (finite, name) => {
    const program = { finite, name };
    return await api.post('/1.0/coach/programs/create', program);
};

export const createWorkoutForDay = async (programId, timelineDay, session) =>
    // eslint-disable-next-line
    await api.post(
        `/2.0/coach/calendar/workout/createWorkoutForTimelineDay/${programId}/${timelineDay}/${session}`
    );

export const createWorkoutForDateDay = async (
    programId,
    year,
    month,
    day,
    session
) =>
    // eslint-disable-next-line
    await api.post(
        `/2.0/coach/calendar/workout/createWorkoutForDay/${programId}/${year}/${month}/${day}/${session}`
    );

export const dialogAndRedirect = (title, redirectPath) => {
    DialogService.inform(
        'Unable to access',
        `You do not have permission to edit ${title}.`,
        () => window.location.path(redirectPath)
    );
};

export const exportAsProgram = async (program) =>
    await api.post('/2.0/coach/calendar/exportAsProgram', program);

export const getAll = async (page, pageSize, type, includeFree) => {
    let queryString = '?';
    if (page) queryString += `page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    if (type) queryString += `&type=${pageSize}`;
    if (includeFree) queryString += `&free=${includeFree ? 1 : 0}`;

    return await api.get(`/1.0/coach/programs${queryString}`);
};

export const getAthleteCalendar = async (id, year, month, padding, onFail) =>
    await api.get(
        `/2.0/coach/athlete/calendar/edit/${id}/${year}/${month}/${padding}`,
        onFail
    );

export const getInvitedAthleteCalendar = async (
    inviteId,
    year,
    month,
    padding,
    onFail
) =>
    await api.get(
        '/2.0/coach/athlete/calendar/invite' +
            `/${inviteId}/${year}/${month}/${padding}`,
        onFail
    );

export const getAthleteExtraWork = async (id, year, month, padding) =>
    await api.get(
        `/2.0/coach/athlete/calendar/extra/${id}/${year}/${month}/${padding}`
    );

export const getAthleteNutrition = async (id, startDate, endDate) =>
    await api.get(
        `/v5/calendars/athletes/${id}/nutrition?startDate=${startDate}&endDate=${endDate}`
    );

export const getAthleteCalendarSummary = async (id, year, month, padding) =>
    await api.get(
        `/2.0/coach/athlete/calendar/summary/${id}/${year}/${month}/${padding}`
    );

export const getAthleteSummaryForProgramWorkout = async (
    programWorkoutId,
    athleteId
) =>
    await api.get(
        `/2.0/coach/athlete/calendar/feed/${programWorkoutId}/${athleteId}`
    );

export const getById = async (id) => await api.get(`/3.0/coach/program/${id}`);

export const getByIdWithDateRange = async (id, year, month, padding, onFail) =>
    await api.get(
        `/1.0/coach/programs/edit/${id}/${year}/${month}/${padding}`,
        onFail
    );

export const getFixedLengthPrograms = async () => await api.get('/v5/programs');

export const getCalendarPrograms = async (teamId) =>
    await api.get(`/1.0/coach/programs/taggedByTeam/${teamId}?type=1`);

export const getPreview = async (type, id) =>
    await api.get(`/2.0/coach/preview/${type}/${id}`);

export const getWorkoutPreview = async (workoutId) =>
    await api.get(`/2.0/coach/preview/workout/${workoutId}`);

export const getProgramById = async (id, onFail) =>
    await api.get(`/1.0/coach/programs/edit/${id}`, onFail);

export const getProgramSettings = async (id) =>
    await api.get(`/1.0/coach/programs/extraDetail/${id}`);

export const getProgramWorkoutPreviewAndSummary = async (
    programWorkoutId,
    userId
) =>
    await api.get(
        `/2.0/coach/preview/workoutAndSummary/${programWorkoutId}/${userId}`
    );

export const getProgramsForUser = async (orgId, userId) =>
    await api.get(`/2.0/coach/admin/groups/${orgId}/${userId}`);

export const getProgramKey = (programId, isProgram, year, month) => {
    if (isProgram) {
        return programId;
    }
    return `${programId}_${year}_${month}`;
};

export const getSports = async () => await api.get('/4.0/library/sports');

export const getTeamByProgramId = async (programId) => {
    if (!(programId in teamProgramCache)) {
        teamProgramCache[programId] = await api.get(
            `/1.0/coach/programs/getTeamByProgram/${programId}`
        );
    }
    return teamProgramCache[programId];
};

export const getTeamCalendarSummary = async (id, year, month, padding) =>
    await api.get(
        `/2.0/coach/calendar/summary/${id}/${year}/${month}/${padding}`
    );

export const gotoCalendarDay = (programId, month, day, year, programType) => {
    if (ProgramTypes.isInvitedAthleteCalendar(programType)) {
        const path = `/athlete/invite/${programId}/${year}/${month}/${day}`;
        return AppState.navigate(path);
    }

    const typeString = ProgramTypes.convertToString(programType);
    const url = `/${typeString}/${programId}/${year}/${month}/${day}`;
    AppState.navigate(url);
};

export const gotoProgramDay = (programId, week, day) => {
    const url = `/program/${programId}/${week}/${day}`;
    AppState.navigate(url);
};

export const isProgramLoaded = (programKey) => programLoaded === programKey;

export const overrideAndCopy = async (
    fromProgramId,
    toProgramId,
    programWorkoutId,
    type
) =>
    // eslint-disable-next-line
    await api.post(
        `/2.0/coach/calendar/overrideAndCopy/${fromProgramId}/${toProgramId}/${programWorkoutId}/${type}`
    );

export const publishProgramWorkouts = async (programWorkoutIds) =>
    await api.post(
        '/2.0/coach/calendar/programWorkout/publish',
        programWorkoutIds
    );

export const programFinishedLoading = (data) => {
    if (data.status === 403) return userUnableToEditProgram(data);
    return data;
};

export const unpublishProgramWorkouts = async (programWorkoutIds) =>
    await api.post(
        '/2.0/coach/calendar/programWorkout/unpublishWorkouts',
        programWorkoutIds
    );

export const subscribeToProgram = async (
    teamId,
    programId,
    year,
    month,
    padding
) =>
    // eslint-disable-next-line
    await api.post(
        `/1.0/coach/team/subscribeToProgram/${teamId}/${programId}/${year}/${month}/${padding}`
    );

export const subscribeAthleteToProgram = async (
    athleteId,
    programId,
    year,
    month,
    padding
) =>
    // eslint-disable-next-line
    await api.post(
        `/1.0/coach/team/subscribeAthleteToProgram/${athleteId}/${programId}/${year}/${month}/${padding}`
    );

export const removeProgramWorkout = async (programId, programWorkoutId) => {
    const data = {
        programId,
        pwId: programWorkoutId,
    };
    return await api.post('/2.0/coach/calendar/removeProgramWorkout', data);
};

export const removeProgramWorkoutSet = async (workoutSetId) =>
    await api.post(
        `/2.0/coach/calendar/workout/workoutSet/delete/${workoutSetId}`
    );

export const removeSport = async (id, sportId) => {
    const sport = { sportId };
    return await api.post(`/1.0/coach/programs/removeSport/${id}`, sport);
};

export const saveFromSettings = async (id, group) =>
    await api.put(`/1.0/coach/programs/extraDetail/${id}`, group);

export const saveProgramWorkouts = async (programWorkouts) =>
    await api.post(
        '/2.0/coach/calendar/programWorkout/saveMany',
        programWorkouts
    );

export const saveProgramWorkoutSets = async (sets) =>
    await api.post('/2.0/coach/calendar/saveProgramWorkoutSets', sets);

export const saveWorkoutSet = async (theSet) =>
    await api.post(
        `/2.0/coach/calendar/workout/workoutSet/save/${theSet.id}`,
        theSet
    );

export const saveWorkoutSetOrder = async (setIds) =>
    await api.post('/2.0/coach/calendar/saveWorkoutSetOrder', setIds);

export const saveWorkoutSetExerciseOrder = async (setExerciseIds) =>
    await api.put('/v5/workoutSetExercises/reorder', setExerciseIds);

export const searchPrograms = async (q, page, pageSize, type) => {
    let queryString = '';
    if (page) queryString = `?page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    if (q) queryString += `&q=${q}`;
    if (type) queryString += `&t=${type}`;

    return await api.get(`/1.0/coach/programs${queryString}`);
};

export const setProgramLoaded = (programKey) => {
    programLoaded = programKey;
};

export const setupCache = () => {
    if (!programCache) {
        programCache = getAll();
    }
    return programCache;
};

export const undoRemoveProgramWorkout = async (programId, programWorkoutId) => {
    const data = {
        programId,
        pwId: programWorkoutId,
    };
    return await api.post('/2.0/coach/calendar/undoRemoveProgramWorkout', data);
};

export const unPublishProgramWorkout = async (programWorkoutId) =>
    await api.post(
        `/2.0/coach/calendar/programWorkout/unPublish/${programWorkoutId}`
    );

export const userUnableToEditProgram = (data) => {
    let redirectPath = '/team';
    switch (parseInt(data.type, 10)) {
        case 0:
            redirectPath = '/team';
            break;
        case 1:
            redirectPath = '/program';
            break;
        case 2:
            redirectPath = '/program/template';
            break;
        case 3:
            redirectPath = '/athletes';
            break;
        case 4:
            redirectPath = '/athletes';
            break;
        default:
            redirectPath = '/';
    }
    return dialogAndRedirect(data.title, redirectPath);
};
